import React, { useState } from "react";
import { resetPassRequest } from "../store/auth/AuthActions.js";
import logoUrl from "img/zeta-logo.png";
import { Links } from "./Links.jsx";

export const ResetRequestForm = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [email, setEmail] = useState("");

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        resetPassRequest(email).then(()=>{
            setLoading(false);
            location.href="/#/";
        }, (e)=>{
            setLoading(false);
            setError(e.message);
        })
    }

    let body = null;
    if(loading)
    {
        body = <div id="loading-display">
            <p><i className="fa fa-spinner fa-pulse fa-2x"></i></p>
            <h2>Requesting password reset..</h2>
        </div>;
    }else{
        body = <div id="login-form">
            <label htmlFor="inputEmail" className="sr-only">Email address</label>
            <input value={email} onChange={ e => setEmail(e.target.value)} type="email" id="inputEmail" className="form-control" placeholder="Email address" required />

            <div id="button-box" style={{ marginTop: "10px" }}>
                <button type="submit" className="btn btn-lg btn-primary btn-block" id="signin" >Reset Password</button>
                <a href="#/" className="btn btn-lg btn-block" id="register">Cancel</a>
                <a href="#/help">Help</a>
            </div>
        </div>
    }

    
    return <form className="form-signin" id="login" onSubmit={onSubmit}>
        <img className="zeta-logo" src={logoUrl}/>
        <h3>Reset Password</h3>
        {error ? 
            <div className="alert alert-danger" role="alert" id="error-message">Reset failed: { error }</div>
            :
            null
        }
        {body}
        <Links/>
    </form>;
}